import { rankList } from '@/mocks/homeData';
import SectionHeading from '@/pages/home/components/SectionHeading';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-600',
  down: 'ri-arrow-down-line text-accent-600',
  flat: 'ri-subtract-line text-foreground-400',
};

const rankBadge = ['bg-primary-500 text-white', 'bg-primary-400 text-white', 'bg-secondary-400 text-white'];

export default function RankBoard() {
  return (
    <section id="rank" className="border-b border-background-200 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="吃瓜热度榜"
          title="此刻热度最高的六条"
          desc="按讨论量与转发量滚动计算，每十分钟刷新一次；榜单只代表此刻热闹，不代表结论。"
          action={
            <span className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-100 px-3 py-2 text-xs font-medium text-secondary-900">
              <i className="ri-refresh-line"></i>
              10:24 更新
            </span>
          }
        />

        <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {rankList.map((item, index) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 px-4 py-4 md:px-6 ${index !== rankList.length - 1 ? 'border-b border-background-200' : ''}`}
            >
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-base ${
                  rankBadge[index] ?? 'bg-background-200 text-foreground-700'
                }`}
              >
                {item.rank}
              </span>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">
                    {item.title}
                  </h3>
                  <span className="rounded-md bg-background-200 px-1.5 py-0.5 text-xs text-foreground-600">
                    {item.tag}
                  </span>
                </div>
                <div className="mt-2.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div
                    className="h-full rounded-full bg-primary-400"
                    style={{ width: `${item.percent}%` }}
                  ></div>
                </div>
              </div>

              <div className="flex w-20 shrink-0 flex-col items-end">
                <span className="font-heading text-base text-foreground-950">{item.heat}</span>
                <span className="mt-1 flex items-center gap-0.5 text-xs">
                  <i className={trendIcon[item.trend]}></i>
                  <span className="text-foreground-500">热度</span>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}